import { Button, ExtendedButtonProps } from '@tink/core/src/components/atoms/Button/Button';
import { alpha } from '@material-ui/core/styles';
import { styled } from '../../../core/theme/styled';

type HeaderButtonProps = ExtendedButtonProps & { hidden?: boolean };

export const StyledButton = styled(Button)<HeaderButtonProps>`
  && {
    /* same height as header */
    height: 44px;
    border-radius: unset;

    /* increase surface where user can click */
    padding: ${(props) => props.theme.sizes.xsmall};
    margin: -${(props) => props.theme.sizes.xsmall};

    /* reset default button styles */
    background-color: transparent;
    border: 0;

    /* other styles */
    display: flex;
    align-items: center;
    cursor: pointer;
    outline: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    /* reset 'Button' styles */
    min-width: 0;

    :focus-visible {
      box-shadow: 0 0 0 3px ${({ theme }) => alpha(theme.configuration.primaryColor, 0.25)};
    }
    ${({ hidden }) => hidden && 'visibility: hidden'};
  }
`;
